import { createContext, useContext, useState } from 'react';

const UserContext = createContext(null);

export const defaultMapConfig = {
  drawPolygons: false,
  position: [38.9848, -77.092689],
  fov: 50,
  altitudeRange: [0, 30000],
  terraBases: false,
  imagery: false,
  occupancy: false,
  mgrs: false,
  terrain: true,
  aois: true,
  ai: process.env?.REACT_APP_AI ? JSON.parse(process.env.REACT_APP_AI) : false,
  source: "NAIP",
  world: false,
  tactical: false
}

export const UserProvider = ({ children }) => {
  const [aoi, setAOI] = useState(null);
  const [aois, setAOIs] = useState([]);
  const [polygon, setPolygon] = useState(null);
  const [user, setUser] = useState(null);
  const [imagery, setImagery] = useState(null);
  const [location, setLocation] = useState(null);
  const [login, setShowLogin] = useState(false);
  const [mapContext, setMapContext] = useState(null);
  const [mapConfig, setMapConfig] = useState(defaultMapConfig);
  const [sources, setSources] = useState([]);
  const [tacticalTerraBase, setTacticalTerraBase] = useState(null);
  const [terraBase, setTerraBase] = useState(null);
  const [terraBases, setTerraBases] = useState(null);
  const [worldTerraBase, setWorldTerraBase] = useState(null);

  return (
    <UserContext.Provider value={{ 
      aoi, aois, imagery, location, login, mapConfig, mapContext, polygon, sources, tacticalTerraBase, terraBase, terraBases, user, worldTerraBase,
      setAOI, setAOIs, setImagery, setLocation, setMapConfig, setMapContext, setPolygon, setShowLogin, setSources, setTerraBase, setTerraBases, setUser, setWorldTerraBase, setTacticalTerraBase
    }}>
      {children}
    </UserContext.Provider>
  );
}

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) throw new Error("useUser must be used within a UserProvider");
  return context;
}
